export default "__VITE_ASSET__0da860aa__"